<template>
    <div class="app-container">

        <div v-if="!isSelect" class="filter-container">
            <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">
                新建标题
            </el-button>
        </div>

        <el-table
            ref="multipleTable"
            :row-key="getRowKeys"
            @selection-change="handleSelectionChange"
            v-loading="listLoading"
            :data="list"
            element-loading-text="Loading"
            border
            fit
            highlight-current-row
        >
            <el-table-column
                :reserve-selection="true"
                v-if="isSelect"
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column align="center" label="标题ID" width="95">
                <template slot-scope="scope">
                    {{ scope.row.titleId }}
                </template>
            </el-table-column>
            <el-table-column label="标题">
                <template slot-scope="scope">
                    {{ scope.row.titleName }}
                </template>
            </el-table-column>

            <el-table-column v-if="!isSelect" label="操作" align="center" width="230" class-name="small-padding fixed-width">
                <template slot-scope="{row,$index}">
                    <el-button type="primary" size="mini" @click="handleUpdate(row)">
                        编辑
                    </el-button>

                    <el-button v-if="row.status!='deleted'" size="mini" type="danger" @click="handleDelete(row,$index)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="total>0" :total="total" :page.sync="listQuery.current" :limit.sync="listQuery.pageSize" @pagination="fetchData"/>


        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="70px" style="width: 400px; margin-left:50px;">
                <el-form-item label="标题" prop="titleName">
                    <el-input v-model="temp.titleName"/>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">
                    取消
                </el-button>
                <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import Vue from 'vue';
import {Table, TableColumn, FormItem, Input, Button, Dialog, Loading, Form, MessageBox, Notification, Tabs, TabPane} from 'element-ui';
import Pagination from '@/components/Pagination/index.vue'
import {ToolAdPlatMap} from '../../../../utils/map'
import {adPlatJDOptions, adReportEventJDOptions} from "../../goodsInfo/jd/config";

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Button)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Loading)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification


export default {
    components: {Pagination},
    props: {
        curAdPlatId: {
            type: String,
            default: '400',
            require: true
        },
        isSelect: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        curAdPlatId(curVal, oldVal) {
            if (curVal) {
                this.fetchData();
            }
        }
    },
    data() {
        return {
            listQuery: {
                current: 1,
                pageSize: 10,
            },
            textMap: {
                update: '编辑',
                create: '新建'
            },
            rules: {
                titleName: [{required: true, message: '请输入标题', trigger: 'blur'}, {min: 1, max: 30, message: '最多30个字符', trigger: 'blur'}]
            },
            dialogFormVisible: false,
            list: [],
            dialogStatus: '',
            listLoading: true,
            total: 0,
            temp: {
                titleName: '',
                adPlatId: this.curAdPlatId,
                customerId: '40',
            },
        }
    }
    ,
    created() {
        this.fetchData();
    }
    ,
    methods: {
        getRowKeys(row) {
            return row.titleId;
        },
        fetchData() {
            this.listLoading = true
            this.httpGetList().then(response => {
                this.list = response.data;
                this.total = response.total;
                this.listLoading = false
            })
        }
        ,
        handleTabClick(tab, event) {
            // 切换tab 重新请求列表
            this.titleTab = 'title';
            this.fetchData();
            console.log(this.curAdPlatId);
        }
        ,
        handleTitleTabClick(tab, event) {
            // 切换tab 重新请求列表
        },
        clearSelectList() {
            this.$refs.multipleTable.clearSelection();
        },
        setSelectList(selectList) {
            this.clearSelectList();
            const rows = [];
            // 类型貌似不一样。拼一下
            selectList.forEach(select => {
                this.list.forEach(item => {
                    if (item.titleId == select.titleId) {
                        rows.push(item);
                    }
                });
            });

            rows.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        },
        httpGetList() {
            const query = this.listQuery;
            query.adPlatId = this.curAdPlatId;
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/title/list',
                    data: query,
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        handleCreate() {
            this.resetTemp()
            this.dialogStatus = 'create'
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate()
            })
        }
        ,
        handleUpdate(row) {
            this.temp = Object.assign({}, row) // copy obj
            this.dialogStatus = 'update'
            this.dialogFormVisible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].clearValidate()
            })
        }
        ,
        handleDelete(row, index) {

            this.$confirm(`确定要删除该数据吗？`, {
                type: "warning",
                //beforeClose 阻止关闭弹窗
                beforeClose: async (action, instance, done) => {
                    //下面这行代码就是弹出的确认删除和取消删除
                    if (action === "confirm") {
                        // 调取接口
                        this.deleteData(row);
                        done();
                    } else {
                        //点击其他地方时就相当于点击了false
                        //done 关闭窗口
                        done();
                    }
                }
            })
        }
        ,
        resetTemp() {
            this.temp = {
                titleName: '',
                adPlatId: this.curAdPlatId,
                customerId: '40',
            }
        },
        handleSelectionChange(val) {
            // console.log(val);
            this.$emit("getSelectList", val);
        },
        createData() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.httpAddData(this.temp).then((result) => {
                        this.list.unshift(result)
                        this.dialogFormVisible = false
                        this.$notify({
                            title: '成功',
                            message: '新建成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                }
            })
        }
        ,
        updateData() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    const tempData = Object.assign({}, this.temp)
                    this.httpUpdateData(tempData).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData();
                        this.$notify({
                            title: '成功',
                            message: '更新成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                }
            })
        }
        ,
        deleteData(row) {
            this.httpDeleteData(row).then(() => {
                this.fetchData();
                this.$notify({
                    title: '成功',
                    message: '删除成功',
                    type: 'success',
                    duration: 2000
                })
            })
        }
        ,
        httpAddData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/title/add',
                    data: params,
                    method: 'POST'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        httpUpdateData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/title/update',
                    data: {...params},
                    method: 'POST'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
        httpDeleteData(params) {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateCid/title/delete',
                    data: {...params},
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        }
        ,
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/tool/title/title.vue